// Global live-region messages. `polite` for async status (ported from the landing
// `.billing-status` role="status" aria-live="polite"), `assertive` for errors and
// route-change page announcements.
class Live {
  polite = $state("");
  assertive = $state("");

  announce(message: string): void {
    // Re-set to empty first so identical consecutive messages are re-announced.
    this.polite = "";
    queueMicrotask(() => {
      this.polite = message;
    });
  }

  alert(message: string): void {
    this.assertive = "";
    queueMicrotask(() => {
      this.assertive = message;
    });
  }
}

export const live = new Live();
